import getSubscriptionProvider, { providers } from './getSubscriptionProvider';

export default function subscribedThroughWeb(meProviderName) {
  const provider = getSubscriptionProvider(meProviderName);
  return provider === providers.zuora || provider === providers.recurly;
}
